import { globals } from '@/src/globals'

export const renderNewPost = (data: any, allowedDate: boolean) : string => {
  const title = data.title.rendered
  const code = data.acf.text_code
  const tagline = data.acf.text_tagline
  const description = (data.acf.textarea_description)
    ? data.acf.textarea_description
    : data.acf.textarea_shortenedDescription

  let image: false | string = false
  if (data.acf.image_featureImage) {
    if (data.acf.image_featureImage.width === 535 && data.acf.image_featureImage.height === 400) {
      image = data.acf.image_featureImage.url
    } else {
      image = data.acf.image_featureImage.url as string
      image = image.replace('.jpg', '-535x400.jpg')
    }
  } else {
    image = `${globals.externalInput.wpBaseURL}/assets/images/placeholders/photo_placeholder.jpg`
  }

  const date = data.date
  let processedDate: false|string = false
  if (date && allowedDate) {
    const year = parseInt(date.substring(0, 4))
    const month = parseInt(date.substring(5, 7))
    const day = parseInt(date.substring(8, 10))
    processedDate = `${day}. ${month}. ${year}`
  }

  const link = data.link

  return /* html */ `
  <div class="postList__single js-singlePost">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8 postList__singleTextContent">

          <div class="postList__singleTitleWrapper">
            <a
              href="${link}"
              class="postList__singleTitle"
            >
              ${title} ${code ? /* html */ `<span class="postList__code">${code}</span>` : ''}
                            
            </a>
            ${processedDate ? /* html */ ` <span class="postList__singleDate">${processedDate}</span>` : ''}              
           
          </div>

          ${tagline ? /* html */ ` <div class="postList__singleSubtitle">${tagline}</div>` : ''}    
          ${description ? /* html */ ` <div class="postList__singleDescription">${description}</div>` : ''}    
         
          <a
            href="${link}"
            class="button button--secondary postList__singleButton"
          >zjistit více</a>
        </div>
        <div class="col-12 col-lg-4">
          <a href="${link}">
            <img
              src="${image}"
              alt=""
              class="postList__singlePicture"
            >
          </a>
        </div>
      </div>
    </div>
  </div>
`
}
